import moment from "moment";
import { createSlots } from "./function";

const processTimeSlot = (startTime, endTime, room, unit, slotDifference) => {
  const slotStartTime = new Date(startTime);
  const slotEndTime = new Date(endTime);
  const slotNumber = Math.floor(slotStartTime.getHours() / slotDifference);
  const timeDiff = slotEndTime - slotStartTime;
  room[slotNumber].time += timeDiff;

//   const { unitConsumed, unitSaved } = calculateUnits(timeDiff, p);

//   room[slotNumber].unitSaved += unitSaved;
  room[slotNumber].unit += unit;
//   room[slotNumber].saving = true
};
const findTimeOfCarbonConsumed = (time, room, unit, slotDifference) => {
  const startTime = new Date(time.startTime);
  const endTime = new Date(time.endTime);
  if (startTime.getHours() === endTime.getHours()) {
    processTimeSlot(startTime, endTime, room, unit, slotDifference);
  } else {
    for (let i = startTime.getHours(); i <= endTime.getHours(); i++) {
      if (i === startTime.getHours()) {
        const nextHourStartTime = new Date(startTime).setHours(i + 1, 0, 0, 0);
        processTimeSlot(startTime, nextHourStartTime, room, unit, slotDifference);
      } else if (i === endTime.getHours()) {
        const slotEndTime = new Date(startTime).setHours(i, 0, 0, 0);
        processTimeSlot(slotEndTime, endTime, room, unit, slotDifference);
      } else {
        const slotStartTime = new Date(startTime).setHours(i, 0, 0, 0);
        const nextHourStartTime = new Date(startTime).setHours(i + 1, 0, 0, 0);
        processTimeSlot(slotStartTime, nextHourStartTime, room, unit, slotDifference);
      }
    }
  }
};

export const spendingFunctionCumUnit = (log, slotDifference = 1,housePPU) => {
  if (log.length !== 0) {
   let dayStart = new Date(log[0].ts);
   dayStart.setHours(0, 0, 0, 0);
   let dayEnd = new Date(log[log.length-1].ts);
   dayEnd.setHours(23, 59, 59, 999);
   let totalNetKwh = log.reduce((acc,item)=>acc+item.netkWh,0)
   let totalNetKavh = log.reduce((acc,item)=>acc+item.netVAh,0)
    let numSlots = 24 / slotDifference // Because there are 24 hrs in a day

    let slot = createSlots(slotDifference, numSlots)

    for (let i = 0; i < log.length; i++) {
     
        let startTime =log[i].ts;
        let endTime = log[i].ts;
        findTimeOfCarbonConsumed(
          { startTime: startTime, endTime: endTime },
          slot,
          log[i].netkWh,
          slotDifference,
          false
        );
    }
    let requiredData = {
      data: slot.map((item)=>{return {amount:item.unit*housePPU,...item}}),
      unitRate:housePPU,
      totalNetKwh:totalNetKwh,
      totalNetKavh:totalNetKavh,
      barGraphData:{
        data:slot.map((item)=>{return item.unit}),
        moneyData:slot.map((item)=>{return item.unit*housePPU}),
        categories:slot.map((item)=>{return item.label}),
        totalAmount:slot.reduce((acc,item)=>{return acc+item.unit*housePPU},0),
        totalUnit:slot.reduce((acc,item)=>{return acc+item.unit},0),
      }
    };

    return requiredData
  }else{
    return {
      data: {},
      unitRate:housePPU,
      totalNetKwh:0,
      totalNetKavh:0,
      barGraphData:{
        data:[],
        moneyData:[],
        categories:[],
        totalAmount:0,
        totalUnit:0,
      }
    };
  }
};